<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="类别">
                    <el-select v-model="CateID" placeholder="请选择" clearable filterable class="el-select-medium">
                        <el-option v-for="item in categorysList" :key="item.Cate_ID" :label="item.Cate_Name" :value="item.Cate_ID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="搜索">
                    <el-input v-model="keyword" clearable placeholder="请输入文件名称搜索" class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getDocumentsList()" :loading="loadingBtn" icon="el-icon-search">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table" :style="'min-height:' + maxheight + 'px'">
            <div class="content-table-title">资源下载列表</div>
            <div v-loading="loadingBtn">
                <div class="activities" v-if="activities && activities.length > 0">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item :title="im.Cate_Name" :name="ix + 1" v-for="(im, ix) in activities" :key="ix">
                            <el-timeline :reverse="reverse">
                                <el-timeline-item v-for="(item, index) in im.Docment" :key="index" :timestamp="item.Document_AddTime">
                                    <div>
                                        <div>{{ item.Document_Name }}</div>
                                        <div style="color: #909399">{{ item.Document_Note }}</div>
                                    </div>
                                    <div style="color: #409eff; position: absolute; right: 10px; top: 0px" @click="onDownloadFile(item)">
                                        下载
                                        <i class="el-icon-download"></i>
                                    </div>
                                </el-timeline-item>
                            </el-timeline>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <el-empty description="暂无数据" v-else style="margin: 10vh 0"></el-empty>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'downloadPrefecture',
    data() {
        return {
            keyword: '',
            CateID: '',
            categorysList: [],
            loadingBtn: false,
            activities: [],
            activeNames: [1],
            reverse: false,
            maxheight: 500
        };
    },
    mounted() {
        this.getDocumentCategorys();
        this.getDocumentsList();
        this.$nextTick(() => {
            this.maxheight = this.$setTableMaxHeight('.app-main-content', '.content-head', 10);
        });
    },
    methods: {
        onRefresh() {
            this.keyword = '';
            this.CateID = '';
            this.getDocumentsList();
        },
        //资源获取类别
        getDocumentCategorys() {
            this.$newsApi.getDocumentCategorys().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.categorysList = res.data.data;
                }
            });
        },
        //资源获取列表
        getDocumentsList() {
            this.loadingBtn = true;
            let params = { keyword: this.keyword, CateID: this.CateID };
            this.$newsApi
                .getDocumentsList({ json: JSON.stringify(params) })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.activities = res.data.data.filter((item) => item.Docment && item.Docment.length > 0);
                    }
                    console.log(this.activities);
                })
                .finally(() => (this.loadingBtn = false));
        },
        onDownloadFile(par) {
            window.open(par.Document_Path);
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.el-form-item__label {
    font-weight: 500 !important;
}
/deep/.el-collapse-item__header {
    font-size: 15px;
}
.content {
    // padding: 10px 10px;
    height: calc(100vh - 104px);
    overflow: auto;
}
.content-head {
    background: #fff;
    padding: 0px 20px 20px 20px;
    border-radius: 2px;
}
.content-head-title {
    line-height: 50px;
}
.content-table-title {
    line-height: 50px;
}
.content-table {
    border-radius: 2px;
    background: #fff;
    padding: 0px 20px 20px 20px;
    cursor: pointer;
    margin-top: 10px;
}
.activities {
    padding: 0px 10px 20px 10px;
}
.content-head {
    padding: 15px 20px 5px 20px;
}
</style>
